export default __webpack_public_path__ + "static/media/person.c0737ccd.png";